import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        ref: "modal",
        onClose: _ctx.cleanup
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.owned ? _ctx.t('memories', 'Remove Album') : _ctx.t('memories', 'Leave Album')), 1)
        ]),
        buttons: _withCtx(() => [
          _createVNode(_component_NcButton, {
            onClick: _ctx.save,
            class: "button",
            variant: "error"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('memories', 'Delete')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.owned
          ? _ctx.t('memories', 'Are you sure you want to permanently remove album "{name}"?', { name: _ctx.name })
          : _ctx.t('memories', 'Are you sure you want to leave the shared album "{name}"?', { name: _ctx.name })), 1)
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}